import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import React, { useEffect} from "react";
import _ from "lodash";
import axios from "axios";
import OriginFooter from "../OriginFooter";
import moment from "moment";
import {getLatestNewsFeed} from '../../../actions/newsFeedActions'


function NewsFeed({ redcer,errors, auth, newsFeed ,getLatestNewsFeed}) {
    const [data, setData] = React.useState("");
    const [newsFeedData, setNewsFeedData] = React.useState();

    useEffect(() => {
        // Initialization
        if (_.isEmpty(data)) {
            axios.get("/newsletter.html")
                .then(res => {
                    setData(res.data);
                }).catch(err => {
                    console.log(err)
            });
        }
        if(_.isEmpty(newsFeed)){
            getLatestNewsFeed({})
        }
    }, []);

    // change in data
    // useEffect(() => {
    //     if (!_.isEmpty(redcer.data)) {
    //         setData(redcer.data);
    //         errors = {};
    //     }
    // }, [redcer.data]);

    useEffect(() => {
        if (!_.isEmpty(newsFeed.latestNewsFeed)) {
            setNewsFeedData(newsFeed.latestNewsFeed);
            errors = {};
        }
    }, [newsFeed.latestNewsFeed]);



    return (
        <div>
            <section className="section default-bg clearfix section2" style={{ backgroundColor: '#000', paddingBottom: '14px'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="call-to-action text-center">
                                <div className="row">
                                    <div className="col-sm-12 col-xs-12">
                                        <h2 className="title heading" style={{margin: '0px'}}><strong>DAILY NEWS LETTER</strong></h2>
                                        <small style={{color: '#09afdf', fontWeight: 'bold', fontSize: '23px'}}>Date: {newsFeedData && moment(newsFeedData.date).format("Do MMM, yyyy") }</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="page-start" />

            <section className="section clearfix" style={{padding: '40px 0 45px 0'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{backgroundColor: '#fff', paddingTop: '20px', boxShadow: '-6px 1px 35px #afafaf'}}>
                            <div >
                                {/*?php


									$h = "SELECT * FROM `daily_news`  ORDER BY `id` DESC LIMIT 1";
									$i = mysql_query($h);
									while($j = mysql_fetch_array($i)) {

						?*/}
                                <div className="col-md-12 pv-10" dangerouslySetInnerHTML={{__html:data}}>
                                    {/*?php echo $j[2]; ?*/}
                                </div>
                                {/*?php } ?*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <OriginFooter/>
        </div>
    )
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
    newsFeed: state.newsFeed,
});

export default withRouter(connect(mapStateToProps, {
    getLatestNewsFeed
})(NewsFeed));
